import { tv } from 'tailwind-variants'

export const dividerVariants = tv({
  base: 'shrink-0 border-0 bg-divider',
  variants: {
    orientation: {
      horizontal: 'h-[1px]',
      vertical: 'w-[1px]',
    },
    flexItem: {
      true: 'self-stretch',
      false: '',
    },
    inset: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    { orientation: 'horizontal', inset: true, className: 'mx-2' },
    { orientation: 'vertical', inset: true, className: 'my-2' },
  ],
  defaultVariants: {
    orientation: 'horizontal',
    flexItem: false,
    inset: false,
  },
})
